/**
 * Inline stroke icons for the machine-detail containers table's lifecycle
 * verbs (IA slice 2, docs/product/ui-information-architecture.md §8) — same
 * "real JSX, not `dangerouslySetInnerHTML`" rationale as `app/navIcons.tsx`,
 * copied from the same founder-approved mock (design-ia/FleetMachine.dc.html).
 * `aria-hidden`/`focusable="false"`: each icon sits inside a `<button
 * title="…">` whose title supplies the accessible name, matching every other
 * icon-only control in this app (see `Button`'s callers).
 */
import type { SVGProps } from "react";

function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    />
  );
}

export function RestartIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M21 12a9 9 0 1 1-3-6.7" />
      <path d="M21 3v6h-6" />
    </Icon>
  );
}

export function StopIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <rect x="6" y="6" width="12" height="12" rx="1" />
    </Icon>
  );
}

export function StartIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" {...props}>
      <path d="M7 5v14l12-7z" />
    </svg>
  );
}
